var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-facts"},[_c('h3',[_vm._v("Занимательные факты")]),_vm._v(" "),_c('div',{staticClass:"main-facts__list"},_vm._l((_vm.coloredItems),function(item){return _c('color-item',{key:item.id,attrs:{"data":item}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }